import React, { Component } from 'react'
import IndexHeaderRow from '../common/indexes/indexHeaderRow'
import classnames from 'classnames'
import { History } from 'history'
import { StipulationMapping } from '../tasks/types'
import { connect } from 'react-redux'
import { fetchMappings } from './mappingActions'
import {
  selectMappingIndex,
  selectMappingMeta,
} from '../../reducers/stipulationMappings'
import { withRouter } from 'react-router-dom'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  fetchMappings: Callback
  history: History
  mappings: StipulationMapping[]
}

export class StipulationMappingsIndex extends Component<Props> {
  static displayName = 'Stipulation Mappings'

  componentDidMount() {
    const { fetchMappings } = this.props
    fetchMappings()
  }

  openPage = (mapping: StipulationMapping) => {
    this.props.history.push(`stipulation-mappings/${mapping.id}`)
  }

  renderRow = (mapping: StipulationMapping, index: number) => {
    return (
      <tr
        key={index}
        onClick={() => this.openPage(mapping)}
        className={classnames('index-table__row', 'stipulation-mapping', {
          unmapped: !mapping.adminVerificationType && !mapping.mode,
        })}
      >
        <td className="index-table__cell">{mapping.identifier}</td>
        <td className="index-table__cell">{mapping.adminVerificationType}</td>
        <td className="index-table__cell">{mapping.mode}</td>
        <td className="index-table__cell">{mapping.title}</td>
      </tr>
    )
  }

  render() {
    const { mappings } = this.props

    if (!mappings) {
      return null
    }

    const rows = mappings.map(this.renderRow)

    const headerList = [
      { displayHeader: 'IDENTIFIER', sortable: false },
      { displayHeader: 'AV TYPE', sortable: false },
      { displayHeader: 'MODE', sortable: false },
      { displayHeader: 'TITLE', sortable: false },
    ]

    return (
      <div className="index stipulation-mappings">
        <h2>Stipulation Mappings</h2>

        <table className="index-table">
          <IndexHeaderRow parsedSearch={{}} headerList={headerList} />
          <tbody className="index-table__body">{rows}</tbody>
        </table>
      </div>
    )
  }
}

export const mapStateToProps = (state) => {
  return {
    mappings: selectMappingIndex(state.stipulationMappings),
    meta: selectMappingMeta(state.stipulationMappings),
  }
}

export default withRouter(
  connect(mapStateToProps, {
    fetchMappings,
  })(StipulationMappingsIndex)
)
